import { RefObject, useCallback, useState } from 'react';
import { exportCompressedGif, startRecording } from '../utils/gifCaptureUtils';

interface ExportStatusHook {
  isExporting: boolean;
  exportProgress: number;
  startGifExport: (durationMs: number) => void;
  startCompressedExport: (durationMs: number) => void;
  resetExportState: () => void;
}

export const useExportStatus = (
  svgContainerRef: RefObject<HTMLDivElement | null>
): ExportStatusHook => {
  const [isExporting, setIsExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);

  const resetExportState = useCallback(() => {
    setIsExporting(false);
    setExportProgress(0);
  }, []);

  const startGifExport = useCallback(
    (durationMs: number) => {
      startRecording(svgContainerRef, durationMs, setIsExporting, setExportProgress);
    },
    [svgContainerRef]
  );

  const startCompressedExport = useCallback(
    (durationMs: number) => {
      exportCompressedGif(svgContainerRef, durationMs, setIsExporting, setExportProgress);
    },
    [svgContainerRef]
  );

  return {
    isExporting,
    exportProgress,
    startGifExport,
    startCompressedExport,
    resetExportState,
  };
};

export default useExportStatus;
